import { waterData } from "../../components/Electricity";
import {
  toggleState,
  updateBrandColor,
  setCommodityRates,
  setDashboardData,
  clearDashboardData,
} from "../actions/displayAction";
import { PRIMARY_HEX } from "../../theme/primary";

const brandColor = PRIMARY_HEX;
const currentDisplay = waterData;

function displayReducer(
  state = {
    brandColor: { brandColor },
    currentDisplay,
    commodityRates: {},
    dashboardData: {},
  },
  action,
) {
  switch (action.type) {
    case toggleState.type:
      return {
        ...state,
        currentDisplay: action.payload,
      };

    case updateBrandColor.type:
      return {
        ...state,
        brandColor: action.payload,
      };

    case setCommodityRates.type:
      return {
        ...state,
        commodityRates: {
          ...state.commodityRates,
          [action.payload.commodity]: action.payload.rate,
        },
      };

    case setDashboardData.type: {
      const { estateId, commodity, data } = action.payload;
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          [estateId]: {
            ...(state.dashboardData?.[estateId] || {}),
            [commodity]: data,
          },
        },
      };
    }

    case clearDashboardData.type:
      return {
        ...state,
        dashboardData: {},
        commodityRates: {},
      };

    default:
      return state;
  }
}

export default displayReducer;
